import type { MatrixClient } from 'matrix-js-sdk';
import { createContext, useContext } from 'react';

export interface MatrixContextType {
  client: MatrixClient | null;
}

export const MatrixContext = createContext<MatrixContextType | undefined>(undefined);

export function useMatrixContext(): MatrixContextType {
  const context = useContext(MatrixContext);
  if (!context) {
    throw new Error('useMatrixContext must be used within a MatrixProvider');
  }
  return context;
}
